import { ViewItem } from '@nx-frontend/shared/types';
import { FlexibleBlockTemplate } from '@nx-frontend/shared/types/portal-block-flexible';

export const brickCommon = {
  index: 0,
  enabled: true,
  sortable: false,
  switchable: false,
};

export interface FlexibleBlockView<T extends FlexibleBlockTemplate = FlexibleBlockTemplate>
  extends ViewItem<T['view']> {
  template: T;
}
